import {BaseService} from "./base.service";

class RolesService extends BaseService {

    constructor() {
        super('api/roles')
    }

    getProvidersForSinester() {
        return this.http.post('api/get-providers-for-sinester').then(response => response.data).catch(err => err.message);
    }

}

export const rolesService = new RolesService();
